import React, { useEffect, useState } from 'react'
import Accordion from '@material-ui/core/Accordion'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import HotSwapAccordionDevicesTable from './hot-swap-accordion-devices-table'
import HotSwapLocations from './how-swap-summary-locations'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../../../assets/mui-override.css'

export default function HotSwapAccordionDetails({
    hotSwap,
    locale,
    theme,
    isAdmin,
    exportHotswap
}) {
    const classes = useStyles()
    const [isExpanded, setIsExpanded] = useState(true)
    return (
        <Accordion expanded={isExpanded} className={classes.radius12}>
            <AccordionSummary
                expandIcon={isAdmin && <ExpandMoreIcon />}
                id="panel1a-header"
                onClick={() => setIsExpanded(!isExpanded)}>
                <div className={classes.summaryContainer}>
                    <div className={classes.devicesHeader}>
                        <Typography className={classes.text}>
                            {locale.locations.devicesListTitle}
                        </Typography>
                    </div>
                    <div>
                        <HotSwapLocations
                            locale={locale}
                            exportHotswap={exportHotswap}
                            selectedHotSwapLocations={[
                                {
                                    name: hotSwap.name,
                                    customer_name: hotSwap.customer_name,
                                    device_count: hotSwap.device_count
                                }
                            ]}
                            isAdmin={isAdmin}
                        />
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                {isExpanded && (
                    <HotSwapAccordionDevicesTable
                        devices={hotSwap.devices}
                        locale={locale}
                        customerName={hotSwap.customer_name}
                        theme={theme}
                        isAdmin={isAdmin}
                    />
                )}
            </AccordionDetails>
        </Accordion>
    )
}

const useStyles = makeStyles(theme => ({
    summaryContainer: {
        display: 'flex !important',
        flexDirection: 'column !important',
        width: '100%'
    },
    devicesHeader: {
        marginTop: '12px',
        marginBottom: '12px'
    },
    text: { fontSize: '1rem', lineHeight: '20px' },
    radius12: { borderRadius: 12 }
}))
